<template>
  <div>
    <ToolbarTopAgency />
    <PrintOdds />
  </div>
</template>

<script>
import LoadingSkeleton from '@/components/generic/LoadingSkeleton'
import ToolbarTopAgency from '@/components/generic/ToolbarTopAgency.vue'

const PrintOdds = () => ({
  component: import('@/components/center_widgets/PrintOddsV2'),
  loading: LoadingSkeleton,
  timeout: 200,
})

export default {
  name: 'PrintOddsPage',
  components: { ToolbarTopAgency, PrintOdds },
}
</script>
